import _LanguageServiceAction from "core/actions/common/LanguageServiceAction";


const screenCode = "20A";
class LanguageServiceAction extends _LanguageServiceAction {

}

export default LanguageServiceAction;
